import { render, staticRenderFns } from "./MonthlyReport.vue?vue&type=template&id=187bfb53&scoped=true&"
import script from "./MonthlyReport.vue?vue&type=script&lang=ts&"
export * from "./MonthlyReport.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyReport.vue?vue&type=style&index=0&id=187bfb53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187bfb53",
  null
  
)

export default component.exports